import './card.scss';
import { ClassHelpers } from '@rocketmakers/armstrong';
import * as React from 'react';
import { LinkWrapper } from '../linkWrapper';
export const Card = ({ to, anchorClassName, download, className, children, ...attr }) => (<LinkWrapper to={to} download={download} className={ClassHelpers.classNames('card-wrapper', anchorClassName)}>
    <div className={ClassHelpers.classNames('card', className)} {...attr} data-can-click={!!attr.onClick}>
      {children}
    </div>
  </LinkWrapper>);
Card.defaultProps = {};
